export default function Planning() {
  return <div>
    <center>
        <h1>Planning</h1>
    </center>
  </div>;
}
